module.exports = __webpack_public_path__ + "img/noPiority.ffeaef4f.png";